import { useState, useRef, useCallback, useEffect } from 'react';

export function useSaveToast() {
  const [saveToast, setSaveToast] = useState(null);
  const timerRef = useRef(null);

  const showLessonSaveToast = useCallback((variant, message, durationMs = 3500) => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
    setSaveToast({ variant, message });
    timerRef.current = setTimeout(() => {
      setSaveToast(null);
      timerRef.current = null;
    }, durationMs);
  }, []);

  const dismissLessonSaveToast = useCallback(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
    setSaveToast(null);
  }, []);

  useEffect(() => () => {
    if (timerRef.current) clearTimeout(timerRef.current);
  }, []);

  return { saveToast, showLessonSaveToast, dismissLessonSaveToast };
}
